import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../../../../common/redux/root.reducer'
import { ReturnFormState } from '../types/types'
import Ajv from 'ajv'
import ReturnForm from '../types/ReturnForm.schema.json'

const ajv = new Ajv()
const validate = ajv.compile(ReturnForm)

export const selectOrderReturnState = (state: RootState): ReturnFormState =>
  state.orderReturn

export const validReturn = createSelector(
  selectOrderReturnState,
  ({ returnForm }) => {
    // Remove orderId as this will not be sent in body instead in url
    const { orderId, ...rest } = returnForm
    if (!orderId) return false
    return validate(rest)
  }
)
